export default function WhatWeDo() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Full Policy Review',
      description: 'We explain your coverage, limits, exclusions, deductibles, and rights under state laws so you know what to expect.'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Comprehensive Property Inspection',
      description: 'We inspect for visible and hidden damage — including water migration, smoke penetration, structural issues, and more. Over 80% of property owners have damage they never realized existed.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Claim Documentation & Submission',
      description: 'We prepare detailed estimates, photos, scope of work, and proof-of-loss documents. Our submissions are designed to meet the insurance company\'s standards and eliminate excuses for underpayment.'
    },
    {
      icon: 'ri-discuss-line',
      title: 'Expert Negotiation',
      description: 'Insurance companies routinely minimize payouts. We enforce policy language, apply state regulations, and negotiate aggressively to secure the highest settlement possible.'
    },
    {
      icon: 'ri-building-line',
      title: 'Residential & Commercial Claims',
      description: 'Homes, rentals, offices, retail, industrial, and mixed-use properties — we handle losses of all sizes.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-8 mb-16">
          <div className="lg:col-span-2">
            <div className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-3">Our Services</div>
            <h2 className="text-5xl font-bold text-[#1e3a5f]">Complete Claims Management</h2>
          </div>
          <div className="lg:col-span-3 flex items-center">
            <p className="text-lg text-gray-600 leading-relaxed">
              Most policyholders only learn what their insurance truly covers after a loss. We specialize in helping property owners understand their policy, uncover hidden damage, and receive the full settlement needed to restore their home or business.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all hover:-translate-y-2 border-l-4 border-transparent hover:border-[#FF6B35] group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-6 group-hover:bg-[#FF6B35] transition-colors">
                <i className={`${service.icon} text-4xl text-[#FF6B35] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a5f] mb-4">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}